module.exports = __webpack_public_path__ + "static/media/logcontent1.6a035ea2.PNG";